var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-date-picker',{ref:"okres",attrs:{"mode":"range","show-caps":"","value":_vm.value,"locale":_vm.currentLang,"input-props":_vm.inputProps},on:{"input":function($event){return _vm.$emit('input',$event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }